/**
 * Dostepne typy utworzenia merchanta p24
 */
export const P24MerchantCreationType = {

    FLOW24: {
        id: 0,
        name: 'FLOW24',
        displayText: 'Flow24 (pominięcie rejestracji w Przelewy24)',
        isP24MerchantRequired: true,

        isNameRequired: true,
        isEmailRequired: true,
        isPhoneNumberRequired: false,

        isBasicInfoRequired: true,
        isBusinessInfoRequired: true,
        isBusinessTypeRequired: false,
        isBillingInfoRequired: false,
        isAddressRequired: false,
        isContactPersonRequired: false,
        isRepresentativeRequired: false
    },
    P24: {
        id: 1,
        name: 'P24',
        displayText: 'Flow24 i Przelewy24',
        isP24MerchantRequired: false,

        isNameRequired: true,
        isEmailRequired: true,
        isPhoneNumberRequired: true,

        isBasicInfoRequired: true,
        isBusinessInfoRequired: true,
        isBusinessTypeRequired: true,
        isBillingInfoRequired: true,
        isAddressRequired: true,
        isContactPersonRequired: true,
        //w zaleznosci od wybranego business type
        isRepresentativeRequired: true
    }

}

/**
 * Kolekcja typow
 */
export const P24MerchantCreationTypeList = Object.keys(P24MerchantCreationType).map(type => P24MerchantCreationType[type])

/**
 * Metoda zwracająca typ działalności bazując na identyfikatorze
 * 
 * @param {int} id identyfikator typu działalności
 * 
 * @returns {P24MerchantCreationType} typ działalności
 */
export const getP24MerchantCreationTypeById = (id) => {

    if (id == null) {
        // Do stuff, will only match null or undefined, this won't match false
        return P24MerchantCreationType.FLOW24;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let businessType = P24MerchantCreationTypeList.find(item => item.id === id)
    return businessType;
}

/**
 * Metoda zwracająca typ działalności bazując na nazwie
 * 
 * @param {String} name nazwa typu działalności
 * 
 * @returns {P24MerchantCreationType} typ działalności
 */
export const getP24MerchantCreationTypeByName = (name) => {
    if (!name) {
        return P24MerchantCreationType.FLOW24;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let businessType = P24MerchantCreationTypeList.find(item => item.name === name)
    return businessType;
}